import { useParams, Link, Navigate } from 'react-router-dom';
import { ArrowRight, FileText, Scale, BookOpen, Briefcase, ClipboardList, Search } from 'lucide-react';
import HeroBanner from '../components/HeroBanner';
import { practiceAreas, paralegalServices } from '../data';
import './ServiceDetail.css';

const serviceIcons = [FileText, Scale, BookOpen, Briefcase, ClipboardList, Search];

export default function ServiceDetail() {
  const { slug } = useParams();

  // Find in practice areas or paralegal services
  const service =
    practiceAreas.find((a) => a.slug === slug) ||
    paralegalServices.find((s) => s.slug === slug);

  if (!service) {
    return <Navigate to="/" replace />;
  }

  const isPracticeArea = practiceAreas.some((a) => a.slug === slug);

  return (
    <>
      <HeroBanner
        title={service.title}
        breadcrumb={service.title}
      />

      {/* Intro Section */}
      <section className="service-intro">
        <div className="container service-intro__grid">
          <div className="service-intro__content">
            {service.tagline && (
              <span className="section-label">Available 24/7 for Your Legal Needs</span>
            )}
            <h2>{service.title}</h2>
            <h4 className="service-intro__tagline">{service.tagline}</h4>
            <p>{service.description}</p>
            <Link to="/contact-us" className="btn btn-primary">
              Request Consultation <ArrowRight size={16} />
            </Link>
          </div>
          <div className="service-intro__image">
            <img
              src={service.detailImage || service.areaImage || service.image}
              alt={service.title}
              loading="lazy"
            />
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="service-offerings">
        <div className="container">
          <div className="text-center">
            <span className="section-label">What We Offer</span>
            <h2 className="section-title">Our {service.shortTitle} Services</h2>
            <p className="section-subtitle">{service.tagline}</p>
          </div>

          <div className="offerings-grid">
            {service.services.map((svc, i) => {
              const Icon = serviceIcons[i % serviceIcons.length];
              return (
                <div key={svc.title} className="offering-card" style={{ animationDelay: `${i * 0.08}s` }}>
                  <div className="offering-card__icon">
                    <Icon size={24} />
                  </div>
                  <h4>{svc.title}</h4>
                  <p>{svc.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Why Choose CTA */}
      <section className="service-cta">
        <div className="service-cta__bg" />
        <div className="container service-cta__content">
          <h2>Why Choose Bridge Legal Services?</h2>
          <p>
            Our trained paralegals ensure accuracy, compliance, and efficient case workflow —
            helping attorneys focus on negotiations and litigation.
          </p>
          <Link to="/contact-us" className="btn btn-primary">
            Request Consultation <ArrowRight size={16} />
          </Link>
        </div>
      </section>
    </>
  );
}
